import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ChannelList from './List/ChannelList';
import * as action from '../store/PlanningBottom.action';
import ChannelInfoModal from './Modal/AddEditChannel';
import Loader from '../../../Components/Utility/Loader/Loader';
import { useComponent } from '../../UserSetting/UsersLibrary/UserRights';

function Channel() {
  const { CheckActionPermission } = useComponent();
  const dispatch = useDispatch();
  const { t } = useTranslation('common');
  const reducer = useSelector((estate) => estate);
  const { PlanningBottomReducer } = reducer;
  const {
    Users: { logInRights },
  } = reducer;
  const [state, setState] = useState({
    showDeleteModal: false,
    selectedIdsArray: [],
  });
  const { selectedIdsArray } = state;
  const { channelInfoModalState, loading } = PlanningBottomReducer;
  const AddEditPlanningBottom = CheckActionPermission(logInRights, 'planning', 'bottomUp', 'addEdit');
  const DeletePlanningBottom = CheckActionPermission(logInRights, 'planning', 'bottomUp', 'delete');

  useEffect(() => {
    const init = async () => {
      await dispatch(action.loaderAction(true));
      await dispatch(action.getChannelList());
      await dispatch(action.loaderAction(false));
    };
    init();
  }, []);

  return (
    <>
      <form>
        <div className="page-title-filter sticky">
          <div className="title-container d-flex align-items-center">
            <h4 className="title w-xs-200px">{t('PLANING_BOTTOM_UP.CHANNEL.PAGE_TITLE')}</h4>
          </div>
          <div className="search-filter">
            {AddEditPlanningBottom && (
              <button type="button" className="filter-btn" onClick={() => dispatch(action.controlChannelModal(true))}>
                <span className="icon-add" />
              </button>
            )}
            {DeletePlanningBottom && (
              <button
                type="button"
                className="filter-btn"
                disabled={!selectedIdsArray.length > 0}
                onClick={() => {
                  setState((prev) => ({
                    ...prev,
                    showDeleteModal: true,
                  }));
                }}
              >
                <span className="icon-delete" />
              </button>
            )}
            <Link className="cursor-pointer text-dark text-decoration-none btn btn-white btn-back-lib" to="/planning/planning-bottomup">
              {t('PLANING_BOTTOM_UP.CHANNEL.BACK_BUTTON_LABEL')}
            </Link>
          </div>
        </div>

        {!loading ? <ChannelList mainState={state} setMainState={setState} /> : <Loader />}
      </form>
      {channelInfoModalState && <ChannelInfoModal />}
    </>
  );
}

export default Channel;
